// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aJcKy","col":"styles_col__1mvTA"};